﻿"use strict";

import * as refs from "./refs.js";

import xlib = refs.xlib;

/** easy cookie query and manipulation.  https://www.npmjs.com/package/js-cookie */
import * as Cookie from "js-cookie"; export { Cookie };

import * as React from "react"; export { React };
import * as ReactDOM from "react-dom"; export { ReactDOM };
import * as Redux from "redux"; export { Redux };
import * as ReactRedux from "react-redux"; export { ReactRedux };
import * as ReactRouter from "react-router"; export { ReactRouter }; //tested with 1.x, not sure if it works with 2.x
import * as History from "history"; export { History };

import * as _ from "lodash";
export var googleAnalytics: typeof ga = <any>function ( ...args: any[] ) {
	if ( typeof ga === "undefined" ) {
		return;
	}
	//fix for new ga bug: http://stackoverflow.com/questions/28765806/existing-google-analytics-events-and-google-tag-manager
	if ( args != null && args.length > 0 && ga.getAll != null ) {
		let arg0 = args[ 0 ];
		if ( arg0 != null && _.isString( arg0 ) && arg0.indexOf( "." ) < 0 ) {
			var trackerName = ga.getAll()[ 0 ].get( 'name' );
			if ( trackerName != null && _.isString( trackerName ) && trackerName.length > 0 ) {
				const newArg = `${ trackerName }.${ arg0 }`;
				args[ 0 ] = newArg;
			}
		}
	}

	return ga.apply( ga, args );
}

/**
 * helper for SPA's to record a pagehit, using the pathname+hash as the page id.
 */
export function ga_ezSpaPageHit() {
	//send page hit
	let spaId = document.location.pathname + xlib.stringHelper.removeAfter( document.location.hash, "?" );
	googleAnalytics( "set", "page", spaId );
	googleAnalytics( "send", "pageview" );
}

/**
 *  //Needed for onTouchTap
//Can go away when react 1.0 release
//Check this repo:
//https://github.com/zilverline/react-tap-event-plugin
 */
//export var injectTapEventPlugin: Function = require( "react-tap-event-plugin" );
//import injectTapEventPlugin from "react-tap-event-plugin"; export { "react-tap-event-plugin"}
export function injectTapEventPlugin() {
	//noop
}

import * as ReactBootstrap from "react-bootstrap"; export { ReactBootstrap };


import * as ReduxDevTools from "redux-devtools"; export { ReduxDevTools }; //v3

class __Monitor extends React.Component<any, any> { }
//export const LogMonitor: typeof __Monitor = require( "redux-devtools-log-monitor" ).default; //need to use ".default" because of es6 module structure
import LogMonitor from "redux-devtools-log-monitor";
export { LogMonitor }

//export const DockMonitor: typeof __Monitor = require( "redux-devtools-dock-monitor" ).default; //need to use ".default" because of es6 module structure
import DockMonitor from "redux-devtools-dock-monitor";
export { DockMonitor }


interface IReduxSimpleRouter {
	/** Call this with a react-router and a redux store instance to install hooks that always keep both of them in sync. When one changes, so will the other.

Supply an optional function selectRouterState to customize where to find the router state on your app state. It defaults to state => state.routing, so you would install the reducer under the name "routing". Feel free to change this to whatever you like. */
	syncReduxAndRouter( history: any, store: any, selectRouterState?: Function ): void;
	/** A reducer function that keeps track of the router state. You must to add this reducer to your app reducers when creating the store. If you do not provide a custom selectRouterState function, the piece of state must be named routing. */
	routeReducer: Function;
	/** An action type that you can listen for in your reducers to be notified of route updates. */
	UPDATE_PATH: any;
	/** An action creator that you can use to update the current URL and update the browser history. Just pass it a string like /foo/bar?param=5 as the path argument.

You can optionally pass a state to this action creator to update the state of the current route.

The avoidRouterUpdate, if true, will stop react-router from reacting to this URL change. This is useful if replaying snapshots while using the forceRefresh option of the browser history which forces full reloads. It's a rare edge case. */
	pushPath( path: string, state?: any, avoidRouterUpdate?: boolean | {} ): void;
	/** An action creator that you can use to replace the current URL without updating the browser history.

The state and the avoidRouterUpdate parameters work just like pushPath. */
	replacePath( path: string, state: any, avoidRouterUpdate: boolean | {} ): void;

}
//export var ReduxSimpleRouter: IReduxSimpleRouter = require( "redux-simple-router" );
import * as ReduxSimpleRouter from "redux-simple-router"
export { ReduxSimpleRouter }

// export { ReduxSimpleRouter }
// ReduxSimpleRouter.

/** the output of all redux actions should be in this form */
export interface IActionResult<T> {
	/** required by redux*/
	type: string;  //
	/** our opinionated encapsulation of state changes */
	value: T; // 
	/** if set, we use this for reducing our state, not the general reduction function*/
	reducer?: <TState>( newState: TState ) => TState, //
}
/** Allows declaring the reducer functionality along with the Action method.  so we don't have as many decoupled related features */
export interface IActionAutoReducer<TState> {
	/** required by redux*/
	type: string;  //
	/** displayed in ReduxDevTools, not used otherwise. */
	debugValue?: any; // 
	/** if set, we use this for reducing our state, not the general reduction function*/
	reducer: ( newState: TState ) => TState, //
}

//export var reactStripeCheckout = require( "react-stripe-checkout" );
import * as reactStripeCheckout from "react-stripe-checkout";
export { reactStripeCheckout };
/**
 *  React-Loader, docs here: https://github.com/quickleft/react-loader
easiest way to use example:  <ReactLoader loaded={this.isLoaded}>Finished Loading! put the content you wait on here.</ReactLoader>
 */
//export var ReactLoader: React.ComponentClass<{ loaded: boolean }> = require( "react-loader" );
import ReactLoader from "react-loader"
export { ReactLoader }


///**
// * Easy watching of promise-state (of onClick event).  https://www.npmjs.com/package/react-progress-button
// */
//export var ReactProgressButton: typeof _ReactProgressButton = require("react-progress-button");



//class _ReactProgressButton extends React.Component<{

//	/** Namespace for CSS classes, default is pb- i.e CSS classes are pb- button. */
//	classNamespace?: string;

//	/** Duration(ms) before going back to normal state when an error occurs, default is 1200*/
//	durationError?: number;


//	/** Duration(ms) before going back to normal state when an success occurs, default is 500*/
//	durationSuccess?: number;


//	/**Function to call when the button is clicked; if it returns a Promise then the component will transition to the success/ error state based on the outcome of the Promise*/
//	onClick: () => Promise<any>;


//	/**Function to call when going back to the normal state after an error*/
//	onError?: (err) => void;


//	/**Function to call when going back to the normal state after a success*/
//	onSuccess?: <T>(value?: T) => void;


//	/**State of the button if you do not want to use the functions.Can be '', loading, success, error or disabled.*/
//	state?: string;


//	/**Type of the button (can be 'submit' for example).*/
//	type?: string;

//	/**Id of the form to submit (useful if the button is not directly inside the form).*/
//	form?: string;


//	/** Wether click event should bubble when in loading state }> = require("react-progress-button");*/
//	shouldAllowClickOnLoading?: boolean;
//}, {}>{
//	/**
//	 * Put the button in the loading state.
//	 */
//	loading() { }

//	/** Put the button in the disabled state.*/
//	disable() { }

//	/**
//	 * Put the button in the normal state.*
//	 */
//	notLoading() { }

//	/**
//	 * Put the button in the normal state.*
//	 */
//	enable() { }

//	/**
//	 * Put the button in the success state.Call the callback or the onSuccess prop when going back to the normal state.
//	 * @param param0
//	 */
//	success(callback?:()=>void, dontGoBackToNormal?) { }

//	/**
//	 * Put the button in the error state.Call the callback or the onSuccess prop when going back to the normal state.
//	 * @param callback
//	 */
//	error(callback?: () => void) { }

//}


/**
 *  npm react-google-recaptcha
https://github.com/dozoisch/react-google-recaptcha

example usage:
```
var React = require("react");
var render = require("react-dom").render
var ReCAPTCHA = require("react-google-recaptcha");

function onChange(value) {
	console.log("Captcha value:", value);
}

render(
	<ReCAPTCHA
		ref="recaptcha"
		sitekey="Your client site key"
		onChange={onChange}
	/>,
	document.body
);
```
 */
// export let ReactRecaptcha: React.ComponentClass<{
// 	/** 	The API client key*/
// 	sitekey: string;
// 	/**The function to be called when the user completes successfully the captcha*/
// 	onChange: ( captchaResponse: string ) => void;
// 	/**optional "light" or "dark" The them of the widget (defaults: light)*/
// 	theme?: string;//"light" | "dark";
// 	/** optional "image" or "audio" The type of initial captcha (defaults: image)*/
// 	type?: string;//"image" | "audio";
// 	/**optional The tabindex on the element (default: 0)*/
// 	tabindex?: number;
// 	/** optional callback when the challenge is expired and has to be redone by user. By default it will call the onChange with null to signify expired callback.*/
// 	onExpired?: () => void;
// 	/**optional set the stoken parameter, which allows the captcha to be used from different domains, see reCAPTCHA secure-token*/
// 	stoken?: string;
// }> = require( "react-google-recaptcha" );

import ReactRecaptcha from "react-google-recaptcha"
export { ReactRecaptcha }

